import { FormControl, FormHelperText, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React from 'react';
import { createSelector } from 'reselect';
import lodash from 'lodash';
import { IPumpingStationFlowmeterPulse } from '../../../../@types/model/masterData/pumpingStation/flowmeterPulse';
import MasterDataPumpingStationFlowmeterPulseFunctions from '../../../../store/masterData/pumpingStation/flowmeterPulse/functions';
import { IRootState } from '../../../../@types/redux';
import { connect } from 'react-redux';

interface IPumpingStationFlowMeterPulseSelectorProps {
    value : string;
    disabled ?: boolean;
    className ?: string;
    required ?: boolean;
    onChange : (value : string) => void;

    isLoading : boolean;
    flowMeterPulses : Array<IPumpingStationFlowmeterPulse>;
}

interface IPumpingStationFlowMeterPulseSelectorState { }

class PumpingStationFlowMeterPulseSelectorComponent extends React.PureComponent<IPumpingStationFlowMeterPulseSelectorProps, IPumpingStationFlowMeterPulseSelectorState> {
    constructor(props : IPumpingStationFlowMeterPulseSelectorProps) {
        super(props);

        this.state = {};
    }

    public componentDidMount() {
        MasterDataPumpingStationFlowmeterPulseFunctions.load();
    }


    private readonly onChange = (event : React.ChangeEvent<unknown>, value : {
        label : string;
        value : string;
    } | null | undefined) => {
        this.props.onChange(value?.value ?? '');
    };

    private readonly getData = (state : IPumpingStationFlowMeterPulseSelectorState, props : IPumpingStationFlowMeterPulseSelectorProps) => props.flowMeterPulses;
    private readonly getValue = (state : IPumpingStationFlowMeterPulseSelectorState, props : IPumpingStationFlowMeterPulseSelectorProps) => props.value;
    private readonly getRequired = (state : IPumpingStationFlowMeterPulseSelectorState, props : IPumpingStationFlowMeterPulseSelectorProps) => props.required;


    private readonly getFlowmeterPulses = createSelector([
        this.getData,
    ], (flowMeterPulses) => flowMeterPulses.filter(x => x.isActive).map(x => x.description).sort((a, b) => a.localeCompare(b)));

    private readonly getFlowmeterPulsesForDropdown = createSelector([ 
        this.getRequired, this.getFlowmeterPulses, 
    ], (required, flowMeterPulses) => {
        
        const dropdownData = lodash.map(flowMeterPulses, (element) => ({ label: `${element}`, value: element.toString() }));
        
        if (!required) {
            dropdownData.unshift({
                label: 'ALL',
                value: '',
            });
        }

        return dropdownData;
    });

    private readonly getSelectedValue = createSelector([ 
        this.getValue, this.getRequired, this.getFlowmeterPulses,
    ], (value, required, flowmeterPulses) => {
        if (value) {
            const flowmeterPulse = flowmeterPulses.find(element => element === value);

            if (flowmeterPulse) {
                return { label: flowmeterPulse, value: flowmeterPulse };
            } else {
                return { label: value, value };
            }
        }

        if (!value && !required) {
            return {
                label: 'ALL',
                value: '',
            };
        }

        return null;
    });

    public readonly render = () => {
        const { required, className, disabled } = this.props;

        const dropdownData = this.getFlowmeterPulsesForDropdown(this.state, this.props);

        const value = this.getSelectedValue(this.state, this.props);

        return (
            <FormControl margin={'normal'} fullWidth className={className} disabled={disabled} error={required && !value}>
                <Autocomplete 
                    id={'flowmeterPulse'}
                    options={dropdownData}
                    value={value}
                    getOptionSelected={(option, val) => option.value === val.value}
                    getOptionLabel={option => option.label}
                    onChange={this.onChange}
                    disableClearable={required}
                    openOnFocus
                    renderInput={params => <TextField error={required && !value} {...params} fullWidth label={'Flowmeter Pulse'} />}
                />
                {
                    required && !value &&
                    <FormHelperText error>Required</FormHelperText>
                }
            </FormControl>
        );
    };
}

const mapStateToProps = (state : IRootState) => {
    return { 
        isLoading: state.masterData.pumpingStation.flowmeterPulse.isLoading,
        flowMeterPulses: state.masterData.pumpingStation.flowmeterPulse.flowmeterPulses,
    };
};

const PumpingStationFlowMeterPulseSelector = connect(
    mapStateToProps,
)(PumpingStationFlowMeterPulseSelectorComponent);

export default PumpingStationFlowMeterPulseSelector;